export function getThemeColor(variableName) {
  return window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();
}

export function getChartColors() {
  return [
    getThemeColor("--theme-primary"),
    getThemeColor("--theme-color-green"),
    getThemeColor("--theme-color-red"),
  ];
}
